const tableStrings = {
  emptyStateText: 'There are no matches for your search',
  emptyStateSubText: 'Try searching with another name',
  showMore: 'Show More',
};
export default tableStrings;
